module.exports = __webpack_public_path__ + "img/bluesky3100_00.e63fc260.jpg";